import {type Margin} from '@logistics-frontend/blocks'

import {PIN_HEIGHT, PIN_SIZE} from '../consts'

export function getMarginWithPlacemarkOffset(margin: Margin): Margin {
  const [top = 0, right = 0, bottom = 0, left = 0] = margin || []

  return [top + PIN_HEIGHT, right + PIN_SIZE / 2, bottom, left + PIN_SIZE / 2]
}
